module.exports = __webpack_public_path__ + "static/media/114.f6634c56.jpg";